import { type UseDatePickerContext, DatePicker, useDatePickerContext } from "@ark-ui/react";
import type { ComponentProps } from "react";

type ControlProps = ComponentProps<typeof DatePicker.Control>;
type CustomProps = {
  children?: React.ReactNode | ((props: { context: UseDatePickerContext }) => React.ReactNode);
};
type Props = Omit<ControlProps, keyof CustomProps> & CustomProps;

const Control = ({ children, ...rest }: Props) => {
  const context = useDatePickerContext();

  return (
    <DatePicker.Control {...rest}>
      {typeof children === "function" ? (
        children({ context })
      ) : (
        <DatePicker.Trigger className="w-full">{children}</DatePicker.Trigger>
      )}
    </DatePicker.Control>
  );
};

export default Control;
